module.exports = "<targets-overview></targets-overview>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/kpiAnalytics/kpiAnalytics.html
// module id = 1822
// module chunks = 0